import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
let ServiceIcon = class ServiceIcon extends Vue {
    service;
};
__decorate([
    Prop({ required: true })
], ServiceIcon.prototype, "service", void 0);
ServiceIcon = __decorate([
    Component
], ServiceIcon);
export default ServiceIcon;
